import { FormattedMessage } from '@features/intl';

import styles from './money-back.module.scss';
import classNames from 'classnames';

export const MoneyBack = ({ largerVerticle }: { largerVerticle?: boolean }) => (
  <p
    className={classNames(styles.moneyBack, {
      [styles.moneyBackPV24]: largerVerticle,
    })}
  >
    <FormattedMessage
      defaultMessage="30-day {mark}"
      id="Onboarding.Paywall.Main.MoneyBack"
      values={{
        mark: (
          <b className={styles.moneyBackBold}>
            <FormattedMessage
              id="Onboarding.Paywall.Main.MoneyBack.Mark"
              defaultMessage="money back guarantee"
            />
          </b>
        ),
      }}
    />
  </p>
);
